// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"635":"eaadd97a","688":"3b78abf6","787":"6b61fa3a","814":"cb29ff91"}[chunkId] + ".chunk.js";
};